import React, { useState } from 'react';
import Icon from '../../component/Icon';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import * as ActionCreator from '../../store/actionCreators';
import * as Action from '../../store/actions';

import DatePicker from 'react-date-picker';

import TimePicker from 'react-time-picker';

export const mapUrl =
  'https://media.wired.com/photos/59269cd37034dc5f91bec0f1/191:100/w_1280,c_limit/GoogleMapTA.jpg';

const Contact = () => {
  console.log('Contact.js');
  const [startDate, setStartDate] = useState(new Date());
  const dates = new Date();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [num, setNum] = useState(1);
  const [time, setTime] = useState(dates.toLocaleTimeString());
  // const [date, setDate] = useState(dates.toDateString());
  const state = useSelector((state) => state.auth);
  const handleSubmit = (e) => {
    e.preventDefault();
    if (num === 0) {
      return;
    }
    if (state.user !== null) {
      dispatch(
        ActionCreator.createReservation(
          {
            people: num,
            date: startDate,
            time: time,
          },
          setLoading,
          state.token
        )
      );
      setNum(1);
    } else {
      dispatch({
        type: Action.CREATE_ERROR,
        payload: {
          msg: 'Please login before reservation',
          type: 'error',
        },
      });
    }
  };

  return (
    <div className='my-[5rem]'>
      <div className='max-w-[50rem] mb-12 rounded-xl p-8 w-[100%] drop-shadow-2xl bg-white mx-auto'>
        <h2 className='text-3xl font-[700] w-min mx-auto text-blue-500 border-b-4 mb-4 border-blue-500 '>
          Contact
        </h2>
        <h2 className='font-[600] mb-4 text-darkPrimary'>We are located at</h2>

        <div className='flex gap-12 mb-4'>
          <div className='flex-1'>
            <img src={mapUrl} alt='map' className='block w-full object-cover' />
          </div>
          <div className='flex-1'>
            <h1 className='font-Aclonica text-3xl'>Social Media</h1>
            <p className='text-greySecondary mb-4'>
              Be the first one to know about discounts, offers and events
            </p>

            {/* SOCIAL ICON LINKS */}
            <div className='flex gap-6 mb-4 items-center'>
              <Link to='/'>
                <Icon name='youtube' className='w-5 h-5 fill-darkPrimary' />
              </Link>
              <Link to='/'>
                <Icon name='instagram' className='w-5 h-5 fill-darkPrimary' />
              </Link>
              <Link to='/'>
                <Icon name='facebook' className='w-5 h-5 fill-darkPrimary' />
              </Link>
              <Link to='/'>
                <Icon name='twitter' className='w-5 h-5 fill-darkPrimary' />
              </Link>
            </div>
            {/* CONTACT  */}
            <div className='flex gap-3 text-sm mb-2 items-center text-darkPrimary'>
              <Icon name='telephone' className='w-4 h-4 fill-darkPrimary' />
              <p>+234 081-1236-4568</p>
            </div>
            <div className='flex gap-3 text-sm items-center text-darkPrimary'>
              <Icon name='envelope' className='w-4 h-4 fill-darkPrimary' />
              <p>hello@info.com.ng</p>
            </div>
          </div>
        </div>
        <div className='flex gap-2 items-center'>
          <Icon name='location' className='w-5 h-5 fill-darkPrimary' />
          <p className='text-sm text-darkPrimary'>
            Lorem ipsum dolor sit amet,velit interdum, ac aliquet
          </p>
        </div>
      </div>

      {/* RESERVATIONS */}
      <h2 className='font-[700] mb-6 text-3xl text-center text-darkPrimary'>
        Make Your Reservations
      </h2>
      <p className='leading-4 mb-8 text-center'>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate
        libero et velit interdum, ac aliquet odio mattis.
      </p>

      {/* TABLE RESERVATION COMPONENT */}
      <div className='flex gap-4 mb-8 justify-center items-center'>
        <TableReservation num={num} setNum={setNum} />
        <DateReservation date={startDate} setDate={setStartDate} />
        <TimeReservation time={time} setTime={setTime} />
      </div>
      <button
        onClick={handleSubmit}
        disabled={loading}
        className='flex p-2 hover:opacity-80 transition ease-out disabled:opacity-50 disabled:cursor-wait px-4 uppercase mx-auto my-0  rounded-lg items-center gap-2 bg-greyPrimary'
      >
        <h2 className='font-[600] text-white'>
          {loading ? 'Please wait...' : 'Create Reservations'}
        </h2>
      </button>
    </div>
  );
};

function TableReservation(props) {
  return (
    <div className='flex items-center gap-2'>
      <div className='p-2 w-20 h-20 flex justify-center items-center rounded-md bg-yellow-200'>
        <Icon name='twoPerson' className='w-10 h-10' />
      </div>
      <div>
        <h1 className='font-[600] text-sm'>Table Reservation</h1>
        <div className='flex gap-4 items-center'>
          <h2>Party of</h2>
          <div className='flex gap-4 items-center'>
            <button
              onClick={() => props.setNum((prev) => prev - 1)}
              disabled={props.num <= 0}
              className='w-10 h-10 hover:opacity-70 disabled:cursor-not-allowed disabled:opacity-70 rounded-full  flex items-center justify-center bg-lightBlue'
            >
              <Icon name='minus' className='w-8 h-8 fill-darkPrimary' />
            </button>
            <h2 className='font-[600] text-darkPrimary'>{props.num}</h2>
            <button
              onClick={() => props.setNum((prev) => prev + 1)}
              className='w-10 hover:opacity-70 h-10 rounded-full flex items-center justify-center bg-lightBlue'
            >
              <Icon name='plus' className='w-8 h-8 fill-darkPrimary' />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

function DateReservation(props) {
  return (
    <div className='flex items-center justify-center  gap-2'>
      <div className='p-2 bg-greySecondary w-20 h-20 flex items-center justify-center rounded-md '>
        <Icon name='date' className='w-10 h-10 fill-white' />
      </div>
      <div>
        <div className='flex gap-4 items-center'>
          <div>
            <h1 className='font-[600] text-sm'>Date</h1>
            <DatePicker value={props.date} onChange={props.setDate} />
          </div>
        </div>
      </div>
    </div>
  );
}
function TimeReservation(props) {
  return (
    <div className='flex items-center gap-2'>
      <div className='p-2 w-20 h-20 flex items-center justify-center rounded-md bg-greySecondary'>
        <Icon name='ClockSvg' className='w-10 h-10 fill-white' />
      </div>
      <div>
        <div className='flex gap-4 items-center'>
          <div>
            <h1 className='font-[600] text-sm'>Time</h1>
            <TimePicker onChange={props.setTime} value={props.time} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
